import React, { useEffect, useRef, useState } from 'react'
import { ClientsListVM } from '../../Structure/ViewModels/Admin/ClientsListVM'
import Search from '../Utilities/Search'
import { Router } from '../../Structure/Handlers/Router'
import AddClient from '../Management/AddClient'
import { Accordion, Col, Row } from 'react-bootstrap'
import Profile from '../Client/Profile'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign, faPenToSquare, faPerson, faPersonCane, faPersonRifle, faUser } from '@fortawesome/free-solid-svg-icons'
import ClientSubscribe from '../Management/ClientSubscribe'
import EditClientInfo from '../Client/EditClientInfo'
import { Globals } from '../../Structure/Globals/GlobalObs'

const ClientsList = () => {
    const [vm , setVm] = useState<{viewModel:ClientsListVM}>({viewModel:new ClientsListVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getList()
    },[])

    useEffect(() => {
        const handleScrollPaths = () => {
            
            const elementPaths = scrollableRef.current;
            if (elementPaths) {
                const isNearBottom = elementPaths.scrollTop + elementPaths.clientHeight + 10 >= elementPaths.scrollHeight;
                if (isNearBottom) {
                    control.addClients();
                }
            }
        };
    
        const element = scrollableRef.current;
        if (element) {
            element.addEventListener('scroll', handleScrollPaths);
        }
    
        return () => {
            if (element) {
                element.removeEventListener('scroll', handleScrollPaths);
            }
        };
    }, [control.List]);
    
    const scrollableRef = useRef<HTMLDivElement | null>(null);

    const [selectedButton , setSelectedButton]= useState<string>('0')

  return (
<div className='d-flex flex-column py-3'>
        <div className=' py-3 d-flex  flex-wrap justify-content-between'>
            {
                Globals.auth.User?.permissions.some(a=>a.id=='1')?(
                    <div className='py-2'>
                        <button className='button-I btn-cl-I px-5 py-2' onClick={()=>Router.OpenNormalPage(<AddClient/>)}>اضافة متدرب جديد</button>

                    </div>
                ):(null)
            }
            {
                Globals.auth.User?.permissions.some(a=>a.id=='8')?(
                    <div className='d-flex py-2'>
                        <Search id='marketers' hasNoSelect onSearch={a=>control.Search=a}/>
                    </div>
                ):(null)
            }
            
        </div>
            {
            Globals.auth.User?.permissions.some(a=>a.id=='8')?(
            control.ShowWithMessege(
                <Accordion defaultActiveKey={selectedButton} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                    <Accordion.Item eventKey='1' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} onClick={()=>setSelectedButton(selectedButton=='0'?'1':'0')}>
                    <Accordion.Button className='border-0 border-bottom-0' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
                          <h5 className='px-3'>المتدربين</h5>
                    </Accordion.Button>
                    <Accordion.Body ref={scrollableRef} className='overflow-y-auto'  style={{maxHeight:'500px'}}>
                      <Row>
                        {
                            control.List.map((item,index)=>(
                                <Col key={index} className='px-3 py-4 h-100' xl={6}>
                                    <Row>
                                        <Col md={8} onClick={()=>{ if(Globals.auth.User){ if(Globals.auth.User.permissions.some(a=>a.id=='6'))Router.OpenNormalPage(<Profile id={item.id}/>)  } }}>
                                            <div className='d-flex justify-content-start py-2 fw-bold txt-color-I'>
                                                <div>{item.id}</div>
                                                <div className='px-3'>{item.arabic_name}</div>
                                            </div>
                                            <div className='d-flex flex-wrap'>
                                                <div className='bill bill-II'>
                                                    {item.marketer}
                                                </div>
                                            </div>
                                            <div>
                                                {
                                                    item.subscriptions.map((i,index)=>(
                                                        <span  key={index} style={{fontSize:'14px', color:'rgba(120,120,120,1)'}}>{index==0?'':' - '}{i}</span>
                                                    ))
                                                }
                                            </div>
                                        </Col>
                                        <Col md={4} className='d-flex flex-wrap p-2'>
                                            {
                                                Globals.auth.User?.permissions.some(a=>a.id=='6')?(
                                                    <div className='p-3'>
                                                        <FontAwesomeIcon icon={faUser} color='green' className='my-auto' onClick={()=>Router.OpenNormalPage(<Profile id={item.id}/>)} />
                                                    </div>
                                                ):(null)
                                            }
                                            {
                                                Globals.auth.User?.permissions.some(a=>a.id=='2')?(
                                                    <div className='p-3'>
                                                        <FontAwesomeIcon icon={faPenToSquare} color='green' className='my-auto' onClick={()=>Router.OpenNormalPage(<EditClientInfo id={item.id}/>)} />
                                                    </div>
                                                ):(null)
                                            }
                                            {
                                                Globals.auth.User?.permissions.some(a=>a.id=='3')?(
                                                    <div className='p-3'>
                                                        <FontAwesomeIcon icon={faDollarSign} color='green' className='my-auto' onClick={()=>Router.OpenNormalPage(<ClientSubscribe id={item.id} name={item.arabic_name}/>)} />
                                                    </div>
                                                ):(null)
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            ))
                        }
                          
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
            )):(null)
        }
    </div>

  )
}

export default ClientsList
